import { resolve, inArray, increment, maxKey, minKey, maxKeyByValue } from '@/legacy/lib//util';
import { codeToColour, battleTag } from '@/legacy/lib//template';

export default class Replay {
  constructor (data) {
    Object.assign (this, data);

    for (let player of this.data.game.players) {
      if (
        player.variables &&
        'colour' in player.variables &&
        player.variables ['colour'] !== null
      ) {
        player.colour = player.variables ['colour'];
      }

      player.colour = codeToColour (player.colour);
    }

    for (let event of this.data.game.events) {
      for (let i in event.args) {
        event.args [i] = battleTag ('' + event.args [i]).replace (/\\/g, '');

        let arg    = event.args [i];
        let player = this.getPlayer (arg);

        if (player && !event.colour) {
          event.colour = player.colour;
        }
      }
    }
  }

  hasW3mmd () {
    let w3mmd = this.getW3mmd ();
    return w3mmd && Object.entries (w3mmd).length > 0;
    // return this.data.game.hasW3mmd;
  }

  hasEvents () {
    return this.data.game.events.length > 0;
  }

  hasChat () {
    return this.data.chatlog.length > 0;
  }

  getW3mmd () {
    let w3mmd  = {};
    let counts = {};
    let keys   = [];

    let empty = 0;

    for (let player of this.getPlayers ()) {
      if (player.variables === null) {
        continue;
      }

      for (let key of Object.keys (player.variables)) {
        let value = player.variables [key];
        let type  = typeof (isNaN (+value) ? value : +value);

        if (value === null) {
          empty++;
          continue;
        }

        if (!inArray (key, keys)) {
          keys.push (key);
        }

        if (! (key in counts)) {
          counts [key] = {};
        }

        if (type === 'string') {
          counts [key] [type] = Infinity;
        }

        increment (counts [key], type);
      }
    }

    for (let key of keys) {
      let values  = {};

      let extrema = {
        max:   -Infinity,
        min:    Infinity,
        range:  null
      };

      let bestType = maxKeyByValue (counts [key]);

      // if (empty === this.getPlayers ().length) {
      //   bestType = 'empty';
      // }

      for (let player of this.getPlayers ()) {
        if (player.variables === null) {
          continue;
        }

        values [player.name] = player.variables [key];

        // if (bestType === 'number') {
        //   values [player.name] = +values [player.name];
        // }
        if (player.variables [key] === null) {
          continue;
        }

        extrema.max = Math.max (extrema.max, values [player.name]);
        extrema.min = Math.min (extrema.min, values [player.name]);
      }

      extrema.range = extrema.max - extrema.min;

      if (! (bestType in w3mmd)) {
        w3mmd [bestType] = {};
      }

      w3mmd [bestType] [key] = {
        values:  values,
        extrema: extrema
      }
    }

    for (let bestType in w3mmd) {
      w3mmd [bestType] = Object.keys (w3mmd [bestType]).sort ().reduce (function (result, key) {
        result [key] = w3mmd [bestType] [key];
        return result;
      }, {});
    }

    return w3mmd;
  }

  getEvents () {
    return this.data.game.events;
  }

  getSaver () {
    if (! (this.data.game.saver in this.data.game.players)) {
      return this.data.game.players [0];
    }

    return this.data.game.players [this.data.game.saver];
  }

  getPlayers () {
    return this.data.game.players;
  }

  getPlayer (name) {
    name = battleTag (name);

    for (let player of this.data.game.players) {
      if (battleTag (player.name) === name) {
        return player;
      }
    }

    return null;
  }

  getBestPlayerBy (key) {
    let player = null,
        value  = -Infinity;

    for (let check of this.data.game.players) {
      let test = resolve (key, check);

      if (test === null) {
        continue;
      }

      if (+test > +value) {
        player = check;
        value  = test;
      }
    }

    return player;
  }

  getApmSeries () {
    let series = [];

    for (let player of this.getPlayers ()) {
      let points = [];

      if (!player.activity.length) {
        continue;
      }

      for (let key in player.activity) {
        points.push ({
          x: +key,
          y: player.activity [key]
        });
      }

      series.push ({
        label: battleTag (player.name),
        colour: player.colour,
        points: points
      });
    }

    return series;
  }
}
